export default function QuemSomosSection() {
  return (
    <section className="bg-beige-50 py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <p className="text-xs font-medium tracking-widest text-gray-500 mb-4">SOBRE A BRAVIA</p>
            <h2 className="text-5xl mb-4">
              <span className="font-bold text-gray-400">Construção com</span>
              <br />
              <span className="font-serif italic text-black text-6xl">propósito</span>
            </h2>
            <div className="space-y-6 text-gray-700 text-lg leading-relaxed mt-8">
              <p>
                A <strong>Bravia Group</strong> nasceu da vontade de construir mais do que casas. Construímos lares, oportunidades e relações de confiança com cada investidor.
              </p>
              <p>
                Somos um hub de investidores focado em projetos de construção residencial na Flórida, com processo transparente, acompanhamento constante e compromisso com a entrega.
              </p>
              <p>
                Nossa missão é clara: oferecer previsibilidade, qualidade e retorno consistente para quem acredita no potencial do mercado imobiliário americano.
              </p>
            </div>
          </div>

          <div className="lg:col-span-3">
            <img
              src="https://public.readdy.ai/ai/img_res/acbec03174cddcadf40a6fcdd71c79ee.jpg"
              alt="Time Bravia Group"
              className="w-full h-[500px] object-cover object-top rounded-3xl shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
